import React, { useContext } from 'react';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import { useTranslation } from 'react-i18next';

import { IndicatorInfos } from '../components/IndicatorInfos';
import { useResponsive } from '../hooks/useResponsive';
import { RatioTheoryPieChart } from '../components/RatioTheoryPieChart';
import { RatioTypePieChart } from '../components/RatioTypePieChart';
import { ExploreContext } from '../context/ExploreContext';

export const IndicatorContainer = ({
  drawnLength,
  describedLength,
  theoreticalLength,
  walkLength,
  walkCycleLength,
  valueShown,
  pointCrossNumber,
  pathCrossNumber,
  interval,
}) => {
  const { isDesktop, isMobile } = useResponsive();
  const { status } = useContext(ExploreContext);
  const { t } = useTranslation();

  const style = {
    container: {
      display: 'flex',
      width: '100%',
      alignItems: 'center',
      overflowX: 'hidden',
      overflowY: 'scroll',
    },
    gridContainer: {
      display: 'flex',
      width: '90%',
      justifyContent: 'center',
    },
    gridItem: {
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
      minHeight: isMobile ? null : '400px',
    },
    indicatorInfosContainer: {
      display: 'flex',
      width: '95%',
      borderRadius: '1em',
    },
  };

  return (
    <Stack sx={style.container} direction='column' spacing={isDesktop ? 6 : 3}>
      <Box sx={style.indicatorInfosContainer}>
        <IndicatorInfos
          status={status}
          drawnLength={drawnLength}
          describedLength={describedLength}
          theoreticalLength={theoreticalLength}
          walkLength={walkLength}
          walkCycleLength={walkCycleLength}
          pointCrossNumber={pointCrossNumber}
          pathCrossNumber={pathCrossNumber}
        />
      </Box>
      {interval === 0 && !isDesktop && (
        <hr style={{ display: 'flex', width: '95%' }} />
      )}
      {interval === 0 && (
        <Grid
          container
          sx={style.gridContainer}
          rowSpacing={5}
          columnSpacing={1}
        >
          <Grid
            sx={style.gridItem}
            size={{
              xs: 12,
              md: 6,
            }}
          >
            <RatioTheoryPieChart
              value={drawnLength}
              totalTheory={theoreticalLength}
              color='#42A5F5'
              legend={t('sidebar.legend_painted_chart')}
              title={t('sidebar.sidewalk_proportion_painted_chart_label')}
            />
          </Grid>
          <Grid
            sx={style.gridItem}
            size={{
              xs: 12,
              md: 6,
            }}
          >
            <RatioTheoryPieChart
              value={describedLength}
              totalTheory={theoreticalLength}
              color='#FF7043'
              legend={t('sidebar.legend_saved_chart')}
              title={t('sidebar.sidewalk_proportion_saved_chart_label')}
              valueShown={valueShown}
            />
          </Grid>
          <Grid
            sx={style.gridItem}
            size={{
              xs: 12,
              md: 6,
            }}
          >
            <RatioTypePieChart
              firstValue={drawnLength}
              secondValue={describedLength}
              title={t('sidebar.sidewalk_proportion_method')}
              firstLabel={t('sidebar.legend_painted_chart')}
              secondLabel={t('sidebar.legend_saved_chart')}
              color1='#42A5F5'
              color2='#FF7043'
            />
          </Grid>
          <Grid
            sx={style.gridItem}
            size={{
              xs: 12,
              md: 6,
            }}
          >
            <RatioTypePieChart
              firstValue={pointCrossNumber}
              secondValue={pathCrossNumber}
              title={t('sidebar.geometry_chart_label')}
              firstLabel={t('sidebar.legend_point')}
              secondLabel={t('sidebar.legend_line')}
              color1='#F9B357'
              color2='#A455FF'
            />
          </Grid>
        </Grid>
      )}
    </Stack>
  );
};
